import { physicalEditionCollection } from "../config/physicalEditionConfig";

export const fetchPhysicalEdition = async () => {
  return Promise.resolve(physicalEditionCollection);
};
